<template>
  <div v-if="show" class="kyc-address-document-proof-dialog-container">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>

    <single-message-dialog
      button-text="Dismiss"
      :show="showSameFileDialog"
      :message="sameFileMessage"
      @onContinue="showSameFileDialog=false"
    ></single-message-dialog>

    <single-message-dialog
      button-text="Dismiss"
      :show="showFileNotSupportedDialog"
      message="File format not supported. Please upload PDF or image."
      @onContinue="showFileNotSupportedDialog=false"
    ></single-message-dialog>

    <confirmation-dialog
      :show="showReAttachFrontPageConfirmationDialog"
      :confirmation-message="reAttachFrontPageConfirmationMessage"
      @onConfirm="attachFrontPage"
      @onNotConfirm="showReAttachFrontPageConfirmationDialog=false"
    ></confirmation-dialog>

    <confirmation-dialog
      :show="showReAttachBackPageConfirmationDialog"
      :confirmation-message="reAttachBackPageConfirmationMessage"
      @onConfirm="attachBackPage"
      @onNotConfirm="showReAttachBackPageConfirmationDialog=false"
    ></confirmation-dialog>

    <confirmation-dialog
      :show="showDismissDialog"
      :confirmation-message="dismissDialogMessage"
      @onConfirm="onDismissConfirm"
      @onNotConfirm="showDismissDialog=false"
    ></confirmation-dialog>

    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-with-cross">
        <weex-image
          class="dialog-cross-image"
          @click="onDismissClicked"
          :src="crossImage"
        ></weex-image>

        <div class="dialog-content-below-cross"></div>

        <weex-text class="font-size-base" v-html="documentTypeTitle"></weex-text>

        <wxc-dropdown
          class="dropdown-container"
          title="Document Type"
          default-item="Select"
          :config="dropdownConfig"
          :list="getDocumentTypes"
          @onItemSelected="onDocumentTypeSelected($event.value)"
        ></wxc-dropdown>

        <file-attach-button
          class="margin-top-10"
          ref="front_page"
          file-attach-button-id="front_page"
          text="Front Page"
          :attach-image-des-src="frontImageDesSrc"
          :disabled="true"
          :disabled-button-style="disabledButtonStyle"
          @attachFilesClicked="onAttachFrontPageClicked"
          @filesAttached="onFrontPageAttached($event.files[0])"
        ></file-attach-button>

        <file-attach-button
          class="margin-top-20"
          ref="back_page"
          file-attach-button-id="back_page"
          text="Back Page"
          :attach-image-des-src="backImageDesSrc"
          :disabled="true"
          :disabled-button-style="disabledButtonStyle"
          @attachFilesClicked="onAttachBackPageClicked"
          @filesAttached="onBackPageAttached($event.files[0])"
        ></file-attach-button>

        <wxc-checkbox
          class="margin-top-20"
          :config="checkBoxConfig"
          title="Skip back page if front page has the address and other details"
          @wxcCheckBoxItemChecked="onCheckboxClicked($event.checked)"
        ></wxc-checkbox>

        <div class="input_container" v-if="showAddressProofDocumentNumberInp">
          <weex-text class="input_label">Address Proof Document Number</weex-text>
          <input
            class="input_with_border_bottom"
            v-model="addressProofDocNumber"
            return-key-type="next">
        </div>

        <wxc-button
          text="Continue"
          size="big"
          class="margin-top-20 horizontal-center margin-bottom-20"
          type="blue"
          @wxcButtonClicked="onContinueClicked"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import WxcCheckbox from "../../../weex-ui/packages/wxc-checkbox/index";
import EzUtils from "../../utils/EzUtils";
import { ImageResourcesUtil, DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import FileAttachButton from "../layout/FileAttachButton";
import AlertService from "../core/alert/AlertService";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import SingleMessageDialog from "./SingleMessageDialog";
import ConfirmationDialog from "./ConfirmationDialog";
import { DocumentDescription } from "../../utils/DocumentDetails";
import { Constants } from "../Constants";

export default {
  components: {
    WxcOverlay,
    WxcButton,
    WxcDropdown,
    FileAttachButton,
    WxcCheckbox,
    SingleMessageDialog,
    ConfirmationDialog
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    documentTypeTitle: {
      type: String,
      default: "Select address proof document type"
    },

    documentTypes: {
      type: Array,
      required: true,
      default: () => []
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    },

    addressProofDocumentIdRequired: {
      type: Boolean,
      required: false,
      default: false
    },

    kycOsvAddressProofBack : {
      type: Object,
      required: false,
      default : () => (DocumentDescription.KYC_OSV_ADDRESS_PROOF_BACK)
    },

    kycOsvAddressProofFront : {
      type: Object,
      required: false,
      default : () => (DocumentDescription.KYC_OSV_ADDRESS_PROOF_FRONT)
    }
  },

  data: () => ({
    frontPageFile: null,
    backPageFile: null,
    documentType: null,
    skipBackPage: false,
    showSameFileDialog: false,
    showFileNotSupportedDialog: false,
    showReAttachFrontPageConfirmationDialog: false,
    showReAttachBackPageConfirmationDialog: false,
    showDismissDialog: false,
    addressProofDocNumber: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    resetData() {
      this.frontPageFile = null;
      this.backPageFile = null;
      this.documentType = null;
      this.skipBackPage = false;
      this.showSameFileDialog = false;
      this.showFileNotSupportedDialog = false;
      this.showReAttachFrontPageConfirmationDialog = false;
      this.showReAttachBackPageConfirmationDialog = false;
      this.showDismissDialog = false;
    },

    showKYCAddressProofOptions() {
      this.resetData();
    },

    onCheckboxClicked(checked) {
      this.skipBackPage = checked;
    },

    onDismissClicked() {
      if (this.frontPageFile || this.backPageFile) {
        this.showDismissDialog = true;
      } else {
        this.onDismissConfirm();
      }
    },

    onDismissConfirm() {
      this.showDismissDialog = false;
      this.$emit("onDialogDismiss");
    },

    onDocumentTypeSelected(documentType) {
      this.frontPageFile = null;
      this.backPageFile = null;
      this.documentType = documentType;
    },

    onFrontPageAttached(file) {
      if (EzUtils.isFileAllowedToUpload(file)) {
        this.frontPageFile = file;
      } else {
        this.showFileNotSupportedDialog = true;
      }
    },

    onBackPageAttached(file) {
      if (EzUtils.isFileAllowedToUpload(file)) {
        if (this.frontPageFile.name === file.name) {
          this.showSameFileDialog = true;
        } else {
          this.backPageFile = file;
        }
      } else {
        this.showFileNotSupportedDialog = true;
      }
    },

    onAttachFrontPageClicked() {
      if (this.checkForValidation(false)) {
        if (this.frontPageFile) {
          this.showReAttachFrontPageConfirmationDialog = true;
        } else {
          this.attachFrontPage();
        }
      }
    },

    onAttachBackPageClicked() {
      if (this.checkForValidation(false)) {
        if (!this.frontPageFile) {
          this.showToast("Please upload front page first.");
        } else if (this.backPageFile) {
          this.showReAttachBackPageConfirmationDialog = true;
        } else {
          this.attachBackPage();
        }
      }
    },

    attachFrontPage() {
      this.showReAttachFrontPageConfirmationDialog = false;
      this.$refs.front_page.attachFile();
    },

    attachBackPage() {
      this.showReAttachBackPageConfirmationDialog = false;
      this.$refs.back_page.attachFile();
    },

    onContinueClicked() {
      if (this.checkForValidation(true)) {
        const attachedDocuments = {};
        if (this.frontPageFile) {
          const documentDetails = this.kycOsvAddressProofFront;
          const keyName = documentDetails.keyName ? documentDetails.keyName : documentDetails.name
          attachedDocuments[Constants.DOCUMENT_PURPOSE_ADDRESS + "_" + keyName] = {
            uri: this.frontPageFile,
            documentName: documentDetails.name,
            documentDescription: documentDetails.description,
            documentDirectory: documentDetails.directory,
            documentCategory: Constants.DOCUMENT_PURPOSE_ADDRESS,
            documentType: this.documentType,
            documentProofNumber : this.addressProofDocNumber
          };
        }
        if (this.backPageFile) {
          const documentDetails = this.kycOsvAddressProofBack;
          const keyName = documentDetails.keyName ? documentDetails.keyName : documentDetails.name
          attachedDocuments[Constants.DOCUMENT_PURPOSE_ADDRESS + "_" + keyName] = {
            uri: this.backPageFile,
            documentName: documentDetails.name,
            documentDescription: documentDetails.description,
            documentDirectory: documentDetails.directory,
            documentCategory: Constants.DOCUMENT_PURPOSE_ADDRESS,
            documentType: this.documentType,
            addressProofDocNumber : this.addressProofDocNumber
          };
        }
        this.$emit("onContinue", attachedDocuments);
      }
    },

    checkForValidation(checkForDocuments) {
      if (!this.documentType) {
        this.showToast(MessageConstants.SELECT_DOCUMENT_TYPE);
        return false;
      }

      if (checkForDocuments) {
        if (!this.frontPageFile) {
          this.showToast(MessageConstants.UPLOAD_FRONT_PAGE);
          return false;
        }

        if (!this.skipBackPage && !this.backPageFile) {
          this.showToast(MessageConstants.UPLOAD_BACK_PAGE);
          return false;
        }

        if(this.showAddressProofDocumentNumberInp && !this.addressProofDocNumber){
           this.showToast(MessageConstants.DOCUMENT_NUMBER_ERROR);
          return false;
        }
      }

      return true;
    }
  },

  computed: {
    crossImage() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED);
    },

    getDocumentTypes() {
      const documentTypes = [];
      this.documentTypes && this.documentTypes.forEach(documentType => {
        documentTypes.push({
          title: EzUtils.removeUnderscoreFromString(documentType, ["ID", "PAN"]),
          value: documentType
        });
      });

      return documentTypes;
    },

    getReadableDocumentType() {
      return EzUtils.removeUnderscoreFromString(this.documentType, ["ID", "PAN"]);
    },

    frontImageDesSrc() {
      if (this.frontPageFile) {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN);
      } else {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
      }
    },

    backImageDesSrc() {
      if (this.backPageFile) {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN);
      } else {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
      }
    },

    reAttachFrontPageConfirmationMessage() {
      return `Do you want to reupload <b>${this.getReadableDocumentType} front page</b>? <br>If yes, previous uploaded <b>${this.getReadableDocumentType} front page</b> will be deleted.`;
    },

    reAttachBackPageConfirmationMessage() {
      return `Do you want to reupload <b>${this.getReadableDocumentType} back page</b>? <br>If yes, previous uploaded <b>${this.getReadableDocumentType} back page</b> will be deleted.`;
    },

    dismissDialogMessage() {
      return `Do you want to close? <br>If yes, previous uploaded <b>${this.getReadableDocumentType}</b> will be deleted.`;
    },

    sameFileMessage() {
      return `This file is already uploaded as <b>${this.getReadableDocumentType} front page</b>. Please upload a different file or please select the skip checkbox at the bottom to skip the back page.`
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    checkBoxConfig() {
      return DefaultResourceConfig.CHECK_BOX;
    },

    disabledButtonStyle() {
      return {
        backgroundColor: "#ffffff",
        "border-width": "1px",
        "border-color": "gray",
        "border-style": "solid"
      };
    },

    showAddressProofDocumentNumberInp(){
        return this.documentType!=="AADHAAR" && this.addressProofDocumentIdRequired;
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.kyc-address-document-proof-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
